import { Guid } from 'guid-typescript';

export class CompanyEmailSetting {
  id: Guid;
  moduleId: number;
  isActive: boolean;
}
